var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.487,
    height: 21.995,
    viewBox: "0 0 20.487 21.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 316",
    d: "M195.625 1936.333h.04a5.609 5.609 0 1 0-4-1.661 5.56 5.56 0 0 0 3.96 1.661zm.04-9.245a3.611 3.611 0 0 1 0 7.222h-.034a3.589 3.589 0 0 1-3.568-3.61 3.611 3.611 0 0 1 3.603-3.611z",
    transform: "translate(-185.423 -1925.066)",
    style: {
      fill: "#254089"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 317",
    d: "M195.021 1939.075c-3.46 0-10.243 1.7-10.243 5.634v1.543a2.56 2.56 0 0 0 2.549 2.551h15.391a2.56 2.56 0 0 0 2.547-2.553v-1.541c0-3.933-6.784-5.634-10.244-5.634zm8.223 7.173a.534.534 0 0 1-.529.533H187.33a.533.533 0 0 1-.531-.53v-1.541c0-1.994 4.976-3.611 8.223-3.611s8.223 1.617 8.223 3.611z",
    transform: "translate(-184.778 -1926.808)",
    style: {
      fill: "#254089"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.614628a8857828221fba6505608a90c2.svg";
export { ForwardRef as ReactComponent };